import script from "./SessionInactiveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionInactiveModal.vue?vue&type=script&setup=true&lang=js"

import "./SessionInactiveModal.vue?vue&type=style&index=0&id=5e0a6146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0a6146"]])

export default __exports__